const productInitialState =  {
  catalog:null,
  catalogWithPrice:null,
  ioShipMethod:null,
  selectedPacks:null,
  selectedPackItem:null
};

export default productInitialState;



// WEBPACK FOOTER //
// ./src/store/initialStates/productInitialState.js